
























































import { Vue, Component } from "vue-property-decorator";
import MyForm from "../MyForm";
import axios from "axios";

import { namespace } from "vuex-class";
import { LoginedUser } from "../store/auth/AuthModel";
import router from "../router";

const register = namespace("register");

@Component({})
export default class RegistrationConfirmation extends Vue {

  public confirmed = false;

  public focused = false as boolean;

  public form = new MyForm({
    code: "",
    email: ''
  });

  @register.Getter
  public registeredUser!: LoginedUser;

  @register.Getter
  public fullName!: string;

  goLogin() {
    router.push("/login");
  }

  get focusedClass(): string {
    return this.focused ? "border-b-4" : "border-b-2";
  }

  get bgColor(): string {
    return this.confirmed ? "bg-color text-white" : "";
  }

  confirmCode() {
      this.form.email = this.registeredUser.email
    axios
      .post("/api/confirm-registration", this.form)
      .then(() => {
        this.confirmed = true;
        localStorage.clear()
      })
      .catch(error => {
        this.form.error = error.response.data.errors;
      });
  }
}
